import { CnEntryPoints } from '@/components/cn-entry-points';

export default CnEntryPoints;
